import axiosInstance from '../../../utils/axiosConfig'
import { mobileBackendUrl } from '../../../env'
import type { TaxHarvestingSummaryResponse } from '../types/summary.types'

const TAX_HARVESTING_FINANCIAL_YEAR_STORAGE_KEY = 'taxHarvestingSelectedFinancialYear'

function getCurrentFinancialYear(): number {
  const currentDate = new Date()
  return currentDate.getMonth() >= 3 ? currentDate.getFullYear() : currentDate.getFullYear() - 1
}

export function getSelectedTaxHarvestingFinancialYear(): number {
  const storedFinancialYear = window?.sessionStorage?.getItem(TAX_HARVESTING_FINANCIAL_YEAR_STORAGE_KEY)
  const parsedFinancialYear = Number(storedFinancialYear)
  return Number.isFinite(parsedFinancialYear) && parsedFinancialYear > 0
    ? parsedFinancialYear
    : getCurrentFinancialYear()
}

export function setSelectedTaxHarvestingFinancialYear(financialYear: number) {
  window?.sessionStorage?.setItem(TAX_HARVESTING_FINANCIAL_YEAR_STORAGE_KEY, String(financialYear))
}

function resolveFinancialYear(input?: unknown): number {
  if (typeof input === 'number' && Number.isFinite(input) && input > 0) {
    return input
  }

  if (input && typeof input === 'object' && 'queryKey' in input) {
    const financialYearFromQueryKey = (input as { queryKey?: unknown[] })?.queryKey?.[1]
    if (
      typeof financialYearFromQueryKey === 'number' &&
      Number.isFinite(financialYearFromQueryKey) &&
      financialYearFromQueryKey > 0
    ) {
      return financialYearFromQueryKey
    }
  }

  return getSelectedTaxHarvestingFinancialYear()
}

export async function fetchTaxHarvestingSummary(
  financialYear?: number | { queryKey?: unknown[] }
): Promise<TaxHarvestingSummaryResponse> {
  const resolvedFinancialYear = resolveFinancialYear(financialYear)
  const response = await axiosInstance.get<TaxHarvestingSummaryResponse>(
    `${mobileBackendUrl}/v2/tax-harvesting/user-summary?financialYear=${resolvedFinancialYear}`
  )
  if (!response?.data) {
    throw new Error('Failed to fetch tax harvesting summary')
  }
  return response.data as TaxHarvestingSummaryResponse
}
